export default [
    {
        path: '/city',
        props: true,
        component: () => import('@/views/City'),
    },
];